// Remplace l'année de naissance d'un animal (birthYear) par une date de naissance
// (birthDate, 'YYYY-MM'). Le mois n'étant pas connu, janvier est retenu : 2024 -> '2024-01'.
// Les animaux sans année de naissance gardent une date vide (à saisir).
// Les animaux déjà adaptés (birthDate présent) sont ignorés.

async function applyJob() {
    const animalCollection = global.app.C.Animal.collection

    const animals = await animalCollection.find({birthYear: {$exists: true}, birthDate: {$exists: false}}).toArray()
    if (!animals.length) return {message: "Aucun animal à adapter"}

    let withoutBirthYear = 0
    const operations = animals.map(animal => {
        const hasBirthYear = Number.isInteger(animal.birthYear)
        if (!hasBirthYear) withoutBirthYear++
        return {
            updateOne: {
                filter: {_id: animal._id},
                update: {
                    $set: {birthDate: hasBirthYear ? `${animal.birthYear}-01` : null},
                    $unset: {birthYear: ''}
                }
            }
        }
    })

    const result = await animalCollection.bulkWrite(operations)
    return {message: `${result.modifiedCount} animal(aux) adapté(s), dont ${withoutBirthYear} sans année de naissance (date de naissance à saisir)`}
}

export const job = {
    name: "adaptAnimalBirthDates",
    title: "Adapter la naissance des animaux (année et mois)",
    execute: function(context, callback) {
        applyJob()
            .then(result => callback(null, result))
            .catch(callback)
    }
}
